export const API_URL = process.env.REACT_APP_API_BASE_URL;
// export const API_URL =
// "https://cors-everywhere.herokuapp.com/http://octopi.algologix.com.bd/api";
